import { Injectable } from "@angular/core"
import { BehaviorSubject } from "rxjs"
import { ApiService } from "./api.service"
import { Composition } from "../../../../common-lib/general/classes/general/composition"
import Folder from "../models/folder"
import { Router } from "@angular/router"
import { ContextMenu } from "../models/contextmenu"
import { WindowService } from "./window.service"
import { MenuOptions } from "../components/reusable/menu-options/menu-options.component"

export interface ModalsValueWarning {
    value: any
    type: "bars" | "resolution" | "time-signature" | "key-mode" | "strategy"
    boolean: boolean
    showModal: boolean
}

export interface ScoreCorruptedModalParams {
    saveChanges: () => void
}
export interface ModalsButton {
    type: "primary" | "secondary"
    text: string
    onClick: { <Type>(arg: Type): void }
}
export interface SimpleModal {
    title: string
    message: string
    buttons: ModalsButton[]
}

export interface RenameModal {
    name: string
    title?: string
    onComplete: { (name: string): void }
}
export interface SettingsModalInput {
    type: "audio" | "about"
}

export interface SuccessModalParams {
    title: string
    subtitle: string
    note: string
}
export interface DoActionBeforeModalParameters {
    /**
     * This function is fired when the user clicks on the continue button, and a loading
     * spinner is shown until the promise is resolved.
     */
    action: (dontShowAgain) => Promise<{
        success: boolean
        error?: string
    }>

    /**
     * This function is fire after the modal is closed
     */
    afterAction?: () => void

    cancel?:
        | (() => void)
        | ((dontShowAgain) => Promise<{
              success: boolean
              error?: string
          }>)

    title?: string
    description?: string
    continueButtonText?: string
    color?: "delete"
    modalId?: string
}
@Injectable()
export class ModalService {
    contextMenus = {
        localContextMenu: new BehaviorSubject<MenuOptions<any>>(undefined),
    }

    modals = {
        doActionsBefore: new BehaviorSubject<DoActionBeforeModalParameters>(
            undefined
        ),

        rename: new BehaviorSubject<RenameModal>(undefined),
        simpleModal: new BehaviorSubject<SimpleModal>(null),
        outdatedDesktopApp: new BehaviorSubject<boolean>(false),
        incorrectDesktopAppArch: new BehaviorSubject<boolean>(false),
        autofill: new BehaviorSubject<any>(null),
        enterUsername: new BehaviorSubject<boolean>(false),

        changelog: new BehaviorSubject<boolean>(false),

        settings: new BehaviorSubject<SettingsModalInput>(undefined),
        successModal: new BehaviorSubject<SuccessModalParams | undefined>(
            undefined
        ),
        desktopAppBugReport$: new BehaviorSubject<boolean>(false),
    }

    compatibilityModal: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
        false
    )
    newEmail: BehaviorSubject<string> = new BehaviorSubject<string>("")
    renamedComposition: BehaviorSubject<Composition> =
        new BehaviorSubject<Composition>(null)
    downloadComposition: BehaviorSubject<Composition> =
        new BehaviorSubject<Composition>(null)
    shareComposition: BehaviorSubject<Composition> =
        new BehaviorSubject<Composition>(null)
    shareFolder: BehaviorSubject<Composition> =
        new BehaviorSubject<Composition>(null)
    downloadFolder: BehaviorSubject<Folder> = new BehaviorSubject<Folder>(null)
    deleteFolder: BehaviorSubject<Folder> = new BehaviorSubject<Folder>(null)
    deleteMulti: BehaviorSubject<Object> = new BehaviorSubject<Object>(null)
    renamedFolder: BehaviorSubject<Folder> = new BehaviorSubject<Folder>(null)
    subscriptionDescription: BehaviorSubject<string> =
        new BehaviorSubject<string>("")
    subscriptionEmbed: string = ""
    subscriptionEmbedLink: string = ""
    changePassword: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
        false
    )
    customizePreset: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
        false
    )
    presetUsecase: BehaviorSubject<Object> = new BehaviorSubject<Object>(null)
    billingPreview: BehaviorSubject<any> = new BehaviorSubject<any>(null)
    subscriptionStatusInfo: BehaviorSubject<any> = new BehaviorSubject<any>(
        null
    )

    updateModal: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false)

    justCreatedComposition: BehaviorSubject<boolean> =
        new BehaviorSubject<boolean>(false)
    createFromPlaylist: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
        false
    )

    createType = "preset"

    collaborators = []

    constructionMode: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
        false
    )

    openCompositionModal: BehaviorSubject<string> = new BehaviorSubject<string>(
        undefined
    )

    constructor(
        protected router: Router,
        protected apiService: ApiService,
        private windowService: WindowService
    ) {}

    async getVersion() {
        try {
            let res = await this.apiService.request(
                "/version",
                {},
                "primary",
                "post",
                false
            )

            this.apiService.isUpdating.next(res.updating)

            this.constructionMode.next(res.constructionMode)

            if (
                res.version != null &&
                this.windowService.versionNumber != res.version
            ) {
                if (this.windowService.desktopAppAPI !== undefined) {
                    this.windowService.generalAPI.promptToUpdateApp(true)
                } else {
                    this.updateModal.next(true)
                }
            }
        } catch (e) {
            console.error(e)
        }
    }
}
